import axios from "axios";
import { rootPath } from "@/config/globalParam";
import router from "@/router/index.js";
import { Notification, Message, MessageBox } from "element-ui";
// import { AccessTokenRefreshApi } from "@/api/index";

import loginService from "@/utils/loginService"; //登录服务

let refreshing = false; //是否正在刷新token中
let waitingForRefresh = []; //等待刷新地址
let pendingRequest = []; //用于存储目前状态为pending的请求标识信息

const Axios = axios.create({
  // `baseURL` 将自动加在 `url` 前面，除非 `url` 是一个绝对 URL。
  // 它可以通过设置一个 `baseURL` 便于为 axios 实例的方法传递相对 URL
  baseURL: rootPath,
  timeout: 100000,
  responseType: "json",
  withCredentials: true, // 是否允许带cookie这些
  headers: {
    "Content-Type": "application/json;charset=utf-8"
  }
});

// 把请求视为切换路由就会把pending状态的请求取消，false为不取消
// 打开之后如果想要区分，按下面方式覆盖
// http.Axios.get('/api/test', {
//   routeChangeCancel: false
// })
//router.beforeEach 里面会统一判断该参数，切换路由，
//routeChangeCancel 为true就会关闭取消接口
Axios.defaults.routeChangeCancel = false;

/**
 * 请求的拦截处理
 * @param config - 请求的配置项
 */
const handleRequestIntercept = config => {
  // 区别请求的唯一标识，这里用方法+请求路径+参数
  if (config.method == "get") {
    var params = JSON.stringify(config.params);
  } else {
    params = JSON.stringify(config.data);
  }
  const requestMark = `${config.method} ${config.url}` + params;

  // 新建针对这次请求的axios的cancelToken标识
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  config.cancelToken = source.token;

  // 找当前请求的标识是否存在pendingRequest中，即是否重复请求了
  const markIndex = pendingRequest.findIndex(item => {
    return item.name === requestMark;
  });
  // 存在，即重复了
  if (markIndex > -1) {
    // 取消当前请求，防止重复发出请求
    //方便测试，生产环境调试
    if (process.env.NODE_ENV === "production") {
      window.log = console.log;
      window.log("存在重复请求【requestMark】:", requestMark);
    } else {
      console.log("存在重复请求【requestMark】:", requestMark); //输出错误信息
    }
    source.cancel();
  } else {
    // 设置自定义配置requestMark项，主要用于响应拦截中
    config.requestMark = requestMark;
    // 记录本次请求的标识
    pendingRequest.push({
      name: requestMark,
      cancel: source.cancel,
      routeChangeCancel: config.routeChangeCancel // 可能会有优先级高于默认设置的routeChangeCancel项值
    });
  }

  return config;
};

/**
 * 响应的拦截处理
 * @param config - 请求的配置项
 */
const handleResponseIntercept = config => {
  // 根据请求拦截里设置的requestMark配置来寻找对应pendingRequest里对应的请求标识
  const markIndex = pendingRequest.findIndex(item => {
    return item.name === config.requestMark;
  });
  // 找到了就删除该标识
  markIndex > -1 && pendingRequest.splice(markIndex, 1);
};

//刷新token登录令牌接口
async function refreshTokenMethod() {
  refreshing = true;
  var sendData = {
    grant_type: "refresh_token",
    refresh_token: sessionStorage.getItem("refreshToken")
  };
  loginService(sendData, "/auth/oauth/token")
    .then(resLogin => {
      // console.log(resLogin);
      refreshing = false;
      if (resLogin.code == "0") {
        // 缓存
        sessionStorage.setItem("token", resLogin.access_token);
        sessionStorage.setItem("refreshToken", resLogin.refresh_token);
      } else {
        //清空缓存，去登录
        MessageBox.alert("登录失效，重新登录", "提示", {
          confirmButtonText: "确定",
          callback: action => {
            sessionStorage.clear();
            localStorage.clear();
            router.replace("/login");
          }
        });
      }
    })
    .catch(error => {
      refreshing = false;
      // console.log(error.response.status);
      if (error.response.status == "426") {
        //情况缓存，去登录
        MessageBox.alert("登录失效，重新登录", "提示", {
          confirmButtonText: "确定",
          callback: action => {
            sessionStorage.clear();
            localStorage.clear();
            router.replace("/login");
          }
        });
        // Notification.error({
        //   title: "登录失效，重新登录",
        //   message: "登录失效，重新登录",
        //   duration: 3000
        // });
      }
    });
}

//status 0  后端接口返回错误
//如果返回的数据不符合规范，没有msg消息提示，
//不使用error（error会有大段SQL之类的错误） 前端就直接提示系统错误
//400状态下，传的是error，后端处理过的可以直接使用
// 根据错误信息的长度来控制显示时间长短
function status0(msg) {
  if (msg.length > 15 && msg.length < 20) {
    Message.error({
      message: msg,
      duration: 6000
    });
  } else if (msg.length >= 20) {
    Message.error({
      message: msg,
      duration: 0,
      showClose: true
    });
  } else {
    msg ? Message.error(msg) : Message.error("服务器发生错误[NO Message]");
  }
}

// 后端接口返回token过期
//缓存当时的请求，刷新token，然后重新再请求
async function status2(res) {
  //refresh接口也过期就直接去登录
  console.log(sessionStorage.getItem("refreshToken"));
  if (
    !sessionStorage.getItem("refreshToken") ||
    sessionStorage.getItem("refreshToken") == "undefined"
  ) {
    refreshing = false; //重置状态数据
    waitingForRefresh = []; //等待刷新地址
    //情况缓存，去登录
    sessionStorage.clear();
    localStorage.clear();
    router.replace("/login");
  } else {
    const resolveQueue = new Promise(resolve => {
      // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
      waitingForRefresh.push(() => {
        res.config.baseURL = "";
        resolve(Axios(res.config));
      });
    });
    //刷新token
    if (!refreshing) {
      await refreshTokenMethod();
      // 已经刷新了token，将所有队列中的请求进行重试
      waitingForRefresh.forEach(cb => cb());
      waitingForRefresh = [];
    }
    // 正在刷新token，将返回一个未执行resolve的promise
    return resolveQueue;
  }
}

//添加请求拦截器
Axios.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    config = handleRequestIntercept(config);
    config.headers.Authorization = "Bearer " + sessionStorage.getItem("token");
    return config;
  },
  error => {
    // error 的回调信息
    // console.log("request：error", error);
    return Promise.reject(error.data.error.message);
  }
);

//返回状态判断(添加响应拦截器)
Axios.interceptors.response.use(
  res => {
    // console.log("response：res", res);
    handleResponseIntercept(res.config);
    //对响应数据做些事 200 status 业务状态统一处理，其他返回业务
    //1 错误状态 后端统一给出错误信息
    //0业务正常状态 前端根据这个状态处理后续页面
    //2 是token失效

    if (res.data.code == "1") {
      status0(res.data.msg);
    }
    if (res.data.code == "2") {
      status2(res);
    }
    return res.data;
  },
  error => {
    const response = error.response;
    //重复请求，程序主动取消的
    if (axios.isCancel(error)) {
      return Promise.reject("Error: 请不要重复请求[canceled]");
    }
    //网络错误，未到服务器
    if (!response) {
      return Promise.reject("Error: 网络错误[failed]");
    }

    // console.log("error.response", error.response);

    //最后服务器状态码不是200的情况
    //正常请求报错了，也要处理一下
    handleResponseIntercept(error.response.config);
    //处理400 404 500之类
    if (error.response.status == "500") {
      Notification.error({
        message: error.response.data.msg,
        duration: 3000
      });
    }
    if (error.response.status == "502") {
      Notification.error({
        message: "请重新请求,或者联系管理员",
        duration: 3000
      });
    }
    if (error.response.status == "404") {
      Notification.error({
        message: "请求不存在,请联系管理员",
        duration: 3000
      });
    }
    //token过期
    // if (error.response.status == "401") {
    //   status2(response);
    // }
    if (error.response.status == "400") {
      // console.log(error.response);
      status0(error.response.data.msg);
    }

    return Promise.reject(error.response.status);
  }
);

// 对axios的实例重新封装成一个plugin ,方便 Vue.use(xxxx)
/* eslint-disable */
export default {
  Axios,
  pendingRequest,
  install: function (Vue, Option) {
    Object.defineProperty(Vue.prototype, "$http", { value: Axios });
  }
};